// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getAuth, signInAnonymously, signOut, UserCredential } from "firebase/auth";
import { doc, DocumentData, DocumentReference, getFirestore, setDoc, WithFieldValue } from "firebase/firestore";

import { firebaseSettings } from "../firebase.settings";
import { AnalyticsService } from "./analytics.service";

// Custom firebase service
class FirebaseService {
  private userCredential!: UserCredential;
  private signingIn = false;

  get userUid() {
    return this.userCredential?.user.uid;
  }

  getDocRef(path: string, ...pathSegments: string[]) {
    return doc(db, path, ...pathSegments);
  }

  saveDoc(reference: DocumentReference<DocumentData, DocumentData>, data: WithFieldValue<DocumentData>) {
    return setDoc(reference, data);
  }

  signOutAnonymouysly() {
    signOut(auth);
  }

  signInAnonymouysly() {
    if (this.signingIn) return Promise.resolve(null);
    this.signingIn = true;

    console.info("trying to anonymous signing");

    if (this.userCredential) {
      console.info("user credential found in anonymous signing", this.userUid);
      this.signingIn = false;
      return Promise.resolve(null);
    }
    return signInAnonymously(auth)
      .then(_userCredential => {
        this.userCredential = _userCredential;
        console.info("signed in user uid:", _userCredential.user.uid);
        this.signingIn = false;
        return this.userCredential;
      })
      .catch(error => {
        console.error("sign in error", error);
        this.signingIn = false;
        return Promise.resolve(null);
      });
  }
}

// Initialize Firebase
window.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.NODE_ENV === "development";
const app = initializeApp(firebaseSettings);
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
const db = getFirestore(app);

// https://firebase.google.com/docs/app-check/web/recaptcha-provider?hl=pt&authuser=0&_gl=1*pel81s*_ga*MTQ5NjgyNjIzNi4xNjkwNTAyNDk4*_ga_CW55HF8NVT*MTY5MTcyMTA1MC4yOS4xLjE2OTE3MjExMDQuMC4wLjA.
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6Lcr98orAAAAAANIrDFlAvKmagulQbo8gK16-Ivo"),
  isTokenAutoRefreshEnabled: true,
});

// Custom analytics
export const analyticsService = new AnalyticsService(analytics);
export const firebaseService = new FirebaseService();
